import Vue from 'vue'
import ResourceList from './ResourceList'

const resourceVue = document.getElementById('resources-vue');

if (resourceVue) {
    new Vue({
        render: h => h(ResourceList),
    }).$mount('#resources-vue')
}




// WEBPACK FOOTER //
// ./App/components/ResourceList/index.js